import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import { getArticleById, getRelatedArticles } from "@/mocks/articles";

const articleDetailImages: Record<string, string> = {
  "article-1": "https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20community%20forum%20illustration%20with%20soft%20coral%20and%20peach%20tones%2C%20modern%20Chinese%20web%20design%20aesthetic%2C%20clean%20and%20minimal%20composition%2C%20friendly%20atmosphere%2C%20digital%20community%20concept%20art%2C%20gentle%20gradients%20and%20soft%20shadows%2C%20welcoming%20visual%20style&width=1200&height=500&seq=detail-art-01&orientation=landscape",
  "article-2": "https://readdy.ai/api/search-image?query=A%20group%20of%20friendly%20people%20connecting%20in%20a%20warm%20digital%20community%20space%2C%20soft%20peach%20and%20coral%20color%20palette%2C%20modern%20flat%20illustration%20style%2C%20cozy%20and%20welcoming%20atmosphere%2C%20Chinese%20community%20website%20aesthetic&width=1200&height=500&seq=detail-art-02&orientation=landscape",
  "article-3": "https://readdy.ai/api/search-image?query=A%20fresh%20and%20modern%20digital%20platform%20update%20concept%2C%20smooth%20gradients%20in%20warm%20peach%20tones%2C%20minimalist%20UI%20elements%2C%20clean%20and%20bright%20composition%2C%20technology%20meets%20warmth&width=1200&height=500&seq=detail-art-03&orientation=landscape",
  "article-4": "https://readdy.ai/api/search-image?query=A%20secure%20shield%20concept%20with%20warm%20protective%20glow%2C%20soft%20coral%20and%20amber%20accent%20colors%2C%20digital%20security%20illustration%20with%20friendly%20aesthetic%2C%20modern%20Chinese%20design%20style&width=1200&height=500&seq=detail-art-04&orientation=landscape",
  "article-5": "https://readdy.ai/api/search-image?query=A%20heartwarming%20collection%20of%20handwritten%20letters%20and%20messages%20floating%20in%20a%20warm%20glowing%20space%2C%20soft%20pink%20and%20coral%20tones%2C%20emotional%20connection%20concept&width=1200&height=500&seq=detail-art-05&orientation=landscape",
  "article-6": "https://readdy.ai/api/search-image?query=A%20creative%20personal%20space%20customization%20concept%2C%20warm%20peach%20and%20coral%20color%20scheme%2C%20digital%20profile%20design%20illustration%2C%20modern%20minimal%20style&width=1200&height=500&seq=detail-art-06&orientation=landscape",
  "article-7": "https://readdy.ai/api/search-image?query=A%20beautiful%20travel%20destination%20illustration%20with%20warm%20peach%20and%20coral%20tones%2C%20scenic%20landscape%2C%20modern%20flat%20style%2C%20adventure%20and%20exploration%20theme&width=1200&height=500&seq=detail-art-07&orientation=landscape",
  "article-8": "https://readdy.ai/api/search-image?query=A%20modern%20tech%20discussion%20illustration%20with%20warm%20coral%20accents%2C%20laptop%20and%20code%20elements%2C%20clean%20minimal%20style%2C%20friendly%20developer%20community%20vibe&width=1200&height=500&seq=detail-art-08&orientation=landscape",
  "article-9": "https://readdy.ai/api/search-image?query=A%20healthy%20lifestyle%20illustration%20with%20warm%20peach%20tones%2C%20office%20stretching%20exercises%2C%20modern%20flat%20style%2C%20wellness%20and%20self%20care%20theme&width=1200&height=500&seq=detail-art-09&orientation=landscape",
  "article-10": "https://readdy.ai/api/search-image?query=A%20movie%20and%20entertainment%20illustration%20with%20warm%20coral%20and%20amber%20tones%2C%20film%20reel%20and%20popcorn%2C%20modern%20flat%20style%2C%20fun%20and%20vibrant&width=1200&height=500&seq=detail-art-10&orientation=landscape",
  "article-11": "https://readdy.ai/api/search-image?query=A%20cozy%20solo%20living%20illustration%20with%20warm%20peach%20and%20coral%20tones%2C%20comfortable%20apartment%20scene%2C%20plants%20and%20warm%20lighting%2C%20peaceful%20and%20content%20atmosphere&width=1200&height=500&seq=detail-art-11&orientation=landscape",
  "article-12": "https://readdy.ai/api/search-image?query=A%20premium%20membership%20comparison%20illustration%20with%20warm%20golden%20and%20coral%20accents%2C%20star%20ratings%20and%20features%2C%20clean%20modern%20style&width=1200&height=500&seq=detail-art-12&orientation=landscape",
};

const relatedImages: Record<string, string> = {
  "article-1": "https://readdy.ai/api/search-image?query=A%20warm%20community%20forum%20illustration%20with%20soft%20coral%20tones%2C%20modern%20Chinese%20design%2C%20friendly%20atmosphere&width=400&height=240&seq=rel-art-01&orientation=landscape",
  "article-2": "https://readdy.ai/api/search-image?query=Friendly%20people%20connecting%20in%20a%20warm%20digital%20space%2C%20soft%20peach%20colors%2C%20modern%20flat%20style&width=400&height=240&seq=rel-art-02&orientation=landscape",
  "article-3": "https://readdy.ai/api/search-image?query=A%20fresh%20modern%20digital%20update%20concept%2C%20warm%20peach%20gradients%2C%20minimalist%20style&width=400&height=240&seq=rel-art-03&orientation=landscape",
  "article-4": "https://readdy.ai/api/search-image?query=A%20secure%20shield%20with%20warm%20protective%20glow%2C%20soft%20coral%20accents%2C%20digital%20security%20theme&width=400&height=240&seq=rel-art-04&orientation=landscape",
  "article-5": "https://readdy.ai/api/search-image?query=Heartwarming%20letters%20in%20a%20warm%20glowing%20space%2C%20soft%20pink%20tones%2C%20emotional%20connection&width=400&height=240&seq=rel-art-05&orientation=landscape",
  "article-6": "https://readdy.ai/api/search-image?query=Creative%20personal%20profile%20design%2C%20warm%20peach%20colors%2C%20modern%20minimal%20style&width=400&height=240&seq=rel-art-06&orientation=landscape",
  "article-7": "https://readdy.ai/api/search-image?query=Beautiful%20travel%20destination%2C%20warm%20peach%20tones%2C%20scenic%20landscape%20illustration&width=400&height=240&seq=rel-art-07&orientation=landscape",
  "article-8": "https://readdy.ai/api/search-image?query=Modern%20tech%20discussion%2C%20warm%20coral%20accents%2C%20laptop%20and%20code%2C%20clean%20style&width=400&height=240&seq=rel-art-08&orientation=landscape",
  "article-9": "https://readdy.ai/api/search-image?query=Healthy%20office%20lifestyle%2C%20warm%20peach%20tones%2C%20stretching%20exercises%2C%20wellness%20theme&width=400&height=240&seq=rel-art-09&orientation=landscape",
  "article-10": "https://readdy.ai/api/search-image?query=Movie%20entertainment%2C%20warm%20coral%20tones%2C%20film%20reel%20and%20popcorn%2C%20fun%20vibrant%20style&width=400&height=240&seq=rel-art-10&orientation=landscape",
  "article-11": "https://readdy.ai/api/search-image?query=Cozy%20solo%20living%20apartment%2C%20warm%20peach%20lighting%2C%20plants%2C%20peaceful%20atmosphere&width=400&height=240&seq=rel-art-11&orientation=landscape",
  "article-12": "https://readdy.ai/api/search-image?query=Premium%20membership%20comparison%2C%20warm%20golden%20coral%20accents%2C%20star%20features%2C%20clean%20style&width=400&height=240&seq=rel-art-12&orientation=landscape",
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = id ? getArticleById(id) : undefined;

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-24 pb-16 min-h-screen bg-background-50 flex items-center justify-center">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto rounded-full bg-background-100 flex items-center justify-center mb-5">
              <i className="ri-file-unknow-line text-3xl text-foreground-400"></i>
            </div>
            <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-2">文章未找到</h2>
            <p className="text-foreground-500 mb-6">你访问的文章不存在或已被删除</p>
            <Link to="/" className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap">
              <i className="ri-arrow-left-line"></i> 返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedArticles = getRelatedArticles(article, 3);

  return (
    <>
      <Navbar />
      <main>
        <article className="pt-20 pb-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "分类浏览", href: `/category/${article.categorySlug}` },
                { label: article.category },
                { label: article.title },
              ]}
            />

            <div className="rounded-2xl overflow-hidden mb-8 h-64 md:h-80">
              <img
                src={articleDetailImages[article.id] || articleDetailImages["article-1"]}
                alt={article.title}
                title={`${article.title} - 爱情岛论坛`}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex items-center gap-3 mb-4 flex-wrap">
              <Link
                to={`/category/${article.categorySlug}`}
                className="text-xs font-medium bg-primary-50 text-primary-600 px-3 py-1 rounded-full"
              >
                {article.category}
              </Link>
              <span className="text-xs text-foreground-400">{article.date}</span>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs text-foreground-400 flex items-center gap-1">
                <i className="ri-user-line"></i> {article.author}
              </span>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs text-foreground-400 flex items-center gap-1">
                <i className="ri-eye-line"></i> {article.readCount.toLocaleString()} 阅读
              </span>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs text-foreground-400 flex items-center gap-1">
                <i className="ri-chat-3-line"></i> {article.commentCount.toLocaleString()} 评论
              </span>
            </div>

            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 leading-snug">
              {article.title}
            </h1>

            <div className="prose prose-stone max-w-none">
              {article.content.split("\n\n").map((para, i) => (
                <p key={i} className="text-foreground-700 leading-relaxed mb-5 text-sm md:text-base">
                  {para}
                </p>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-background-200/60">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-sm text-foreground-500">标签：</span>
                <span className="text-xs bg-background-100 text-foreground-600 px-3 py-1.5 rounded-full">爱情岛论坛</span>
                <span className="text-xs bg-background-100 text-foreground-600 px-3 py-1.5 rounded-full">{article.category}</span>
                <span className="text-xs bg-background-100 text-foreground-600 px-3 py-1.5 rounded-full">论坛攻略</span>
              </div>
            </div>
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="py-14 md:py-20 bg-background-100">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-8">相关推荐</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.id}`}
                    className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300"
                  >
                    <div className="h-36 overflow-hidden">
                      <img
                        src={relatedImages[ra.id] || relatedImages["article-1"]}
                        alt={ra.title}
                        title={`${ra.title} - 爱情岛论坛`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs font-medium bg-primary-50 text-primary-600 px-2 py-0.5 rounded-full">
                          {ra.category}
                        </span>
                      </div>
                      <h3 className="font-heading text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                        {ra.title}
                      </h3>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </>
  );
}